var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "disability-badge" }, [
    _c("p", { staticClass: "disability-icon", style: _vm.disabilityIconStyle }),
    _vm._v("\n    " + _vm._s(_vm.disability) + "\n    "),
    _c(
      "button",
      {
        staticClass: "tls-button-icon",
        on: {
          click: function($event) {
            return _vm.$emit("removeDisability", _vm.disability)
          }
        }
      },
      [
        _c("img", {
          attrs: {
            src: "/content/images/circle-cancel.svg",
            alt: "circle-cancel-icon"
          }
        })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }